import { View, Text } from "react-native";
import { ms } from "@/ui/moderateScale";
import { Colors } from "@/constants/Colors";
import { useEffect } from "react";

export default function MigrationToNewVersion() {
  useEffect(() => {
    setTimeout(() => {
      window.open(
        "https://1Transcribe.com?action=login&utm_source=eznote&utm_medium=web",
        "_self"
      );
    }, 2000);
  }, []);

  return (
    <View
      style={{
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
        paddingTop: ms(100),
        paddingHorizontal: ms(12),
      }}
    >
      <Text style={{ fontSize: ms(32), fontWeight: "bold" }}>
        We moved to a new website.{" "}
      </Text>
      <Text
        style={{
          fontSize: ms(24),
          color: Colors.text,
          lineHeight: ms(32),
          marginTop: ms(24),
        }}
      >
        Please use{" "}
        <Text
          onPress={() =>
            window.open(
              "https://1Transcribe.com?action=login&utm_source=eznote&utm_medium=web",
              "_self"
            )
          }
          style={{ color: Colors.accent }}
        >
          https://1Transcribe.com
        </Text>{" "}
        to access the new website.
      </Text>
    </View>
  );
}
